<!-- 签到详情 -->
<template>
  <div class="el-ErrorSet">
    <el-row class="content_block">
      <TitleInfo title="签到详情" :titleImg="qiandao"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-col :span="6">
          <el-row style="overflow: auto;border: 1px solid #DEDEDE;margin-right: 20px;min-height:400px;height: calc(100vh - 220px);padding: 20px;">
            <el-form ref="form" :model="search" label-width="80px">
              <el-form-item label="选择班级">
                <el-select clearable v-model="search.schoolClassId" style="width: 100%;" placeholder="请选择班级">
                  <template v-for="(item ,index) in classList">
                    <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-input placeholder="请输入学号或姓名" style="width: calc(100% - 96px)" prefix-icon="el-icon-search" v-model="search.studentOrName"></el-input>
              <el-button type="primary" icon="el-icon-search" @click="getStudentList(page_stu = 1)">搜索</el-button>
            </el-form>
            <el-table
              :data="studentList"
              @row-click="tableRowClick"
              border
              style="width: 100%;margin-top: 10px;">
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentInfo.studentName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentInfo.studentSn}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 100%;margin-top: 20px;">
              <el-pagination
                @size-change="handleSizeChange_stu"
                @current-change="handleCurrentChange_stu"
                :current-page.sync="page_stu"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit_stu"
                background
                small
                :pager-count="5"
                :hide-on-single-page="true"
                layout="prev, pager, next"
                :total="total_stu">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
        <el-col :span="18">
          <el-row style="margin-bottom: 20px;">
            <label>日期筛选：</label>
            <el-date-picker
              v-model="value1"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间">
            </el-date-picker>
            <label style="margin-left: 5px;">签到情况：</label>
            <el-select v-model="teacherOpenCourseStudentSigninLogTag" style="width: 100px;" placeholder="请选择">
              <el-option value="">请选择</el-option>
              <el-option value="SIGN_IN" label="已签到"></el-option>
              <el-option value="UN_SIGN_IN" label="缺勤"></el-option>
            </el-select>
            <label style="margin-left: 5px;">缺勤理由：</label>
            <el-select v-model="teacherOpenCourseStudentSigninLogRemark" style="width: 100px;" placeholder="请选择">
              <el-option value="">请选择</el-option>
              <el-option value="事假" label="事假"></el-option>
              <el-option value="病假" label="病假"></el-option>
              <el-option value="旷课" label="旷课"></el-option>
              <el-option value="其他" label="其他"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
            <el-button type="primary" icon="el-icon-refresh" @click="refresh">清空</el-button>
            <el-button type="success" icon="el-icon-printer" @click="exportInfo">导出</el-button>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
              <el-table-column prop="studentIdText" header-align="center" align="center" label="姓名"  width="100"> </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号" width="120"> </el-table-column>
              <el-table-column prop="schoolClassIdText" header-align="center" align="center" label="班级" width="120"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninLogTag" header-align="center" align="center" label="签到情况" width="120">
                <template slot-scope="scope">
                  <!-- SIGN_IN（签到）或者UN_SIGN_IN（缺勤） -->
                  <el-link type="primary" v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='SIGN_IN'" :underline="false">已签到</el-link>
                  <el-link type="danger" v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='UN_SIGN_IN'" :underline="false">缺勤</el-link>
                  <span style="color: #a7a7a7;" v-if="scope.row.teacherOpenCourseStudentSigninLogTag == null || scope.row.signType ==''">未签到</span>
                </template>
              </el-table-column>
              <!--
              <el-table-column prop="teacherOpenCourseStudentSigninLogTagText" header-align="center" align="center" label="签到"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninLogTagText" header-align="center" align="center" label="缺勤"> </el-table-column>
              -->
              <el-table-column prop="teacherOpenCourseStudentSigninLogRemark" header-align="center" align="center" label="缺勤理由">
                <template slot-scope="scope">
                  <template v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='UN_SIGN_IN'">
                    <el-select @change="changeRemark(scope.row)" v-model="scope.row.teacherOpenCourseStudentSigninLogRemark" placeholder="请选择">
                      <el-option value="">请选择</el-option>
                      <el-option value="事假">事假</el-option>
                      <el-option value="病假">病假</el-option>
                      <el-option value="旷课">旷课</el-option>
                      <el-option value="其他">其他</el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninLogAddTime" header-align="center" align="center" label="签到日期" width="180"> </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
import {getClassInfo} from "@/common/getInfo"; //加载数据
export default {
  name: "ErrorSet",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      qiandao:require("../../images/course/qiandao-xianxing@2x.png"),
      search:{
        schoolClassId:"",
        studentOrName:""
      },
      value1:"",
      teacherOpenCourseStudentSigninLogRemark:"", //缺勤理由
      teacherOpenCourseStudentSigninLogTag:"", //是否缺勤
      tableData:[],
      studentList:[],
      noticeList:[], //当前页数据

      total: 0,
      limit:10,
      page:1,
      total_stu: 0,
      limit_stu:10,
      page_stu:1,
      classList:[],
      teacherOpenCourseId:this.$route.query.courseId,
      signinSettingId:this.$route.query.signinSettingId,
      seeStudentId:"" //查看相应学生签到情况id
    };
  },
  created() {
    if(this.$isEmpty(this.signinSettingId)){
      this.$message({message: '数据丢失，请重新进入！',type: 'warning'});
      return;
    }
    getClassInfo({teacherOpenCourseId:this.teacherOpenCourseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
        if(ret.data.length >0){
          // this.search.schoolClassId = ret.data[0].schoolClassId;
          this.getStudentList();
        }
      }
    });
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.limit = val;
        this.getInfo();
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getInfo();
    },
    handleSizeChange_stu(val) {
        console.log(`每页 ${val} 条`);
        this.limit_stu = val;
        this.getStudentList();
    },
    handleCurrentChange_stu(val) {
        console.log(`当前页: ${val}`);
        this.page_stu = val;
        this.getStudentList();
    },
    refresh(){
      this.page = 1;
      this.seeStudentId = "";
      this.value1 = "";
      this.teacherOpenCourseStudentSigninLogRemark = "";
      this.teacherOpenCourseStudentSigninLogTag = "";
      this.getInfo();
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        studentId:this.seeStudentId,
        teacherOpenCourseId:this.teacherOpenCourseId,
        teacherOpenCourseStudentSigninSettingId:this.signinSettingId,
        teacherOpenCourseStudentSigninSettingSessionTime:this.value1,
        teacherOpenCourseStudentSigninLogRemark:this.teacherOpenCourseStudentSigninLogRemark,
        teacherOpenCourseStudentSigninLogTag:this.teacherOpenCourseStudentSigninLogTag,
      }
      this.$post("/api/teacherOpenCourseStudentSigninLog/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getStudentList(){ //获取学生列表
      let param = {
        schoolClassIdPlural:this.search.schoolClassId,
        studentSnOrName:this.search.studentOrName,
        limit:this.limit_stu,
        page:this.page_stu,
        teacherOpenCourseId:this.teacherOpenCourseId
      }
      /**
       * 这里要查询已经加入到这个课程的学生列表。
       */
      this.$post("/api/teacherOpenCourseMergeStudent/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total_stu = Number(ret.count);
          this.studentList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    tableRowClick(ow, column, cell, event){
      this.seeStudentId = ow.studentId;
      this.getInfo();
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      //   let param = {
      //   limit:this.limit,
      //   page:this.page,
      //   studentId:this.seeStudentId,
      //   teacherOpenCourseId:this.teacherOpenCourseId,
      //   teacherOpenCourseStudentSigninSettingId:this.signinSettingId,
      //   teacherOpenCourseStudentSigninSettingSessionTime:this.value1,
      //   teacherOpenCourseStudentSigninLogRemark:this.teacherOpenCourseStudentSigninLogRemark,
      //   teacherOpenCourseStudentSigninLogTag:this.teacherOpenCourseStudentSigninLogTag,
      // }
      // this.$post("/api/teacherOpenCourseStudentSigninLog/getPageList.do",param).then((ret) =>{
      //   if(ret.code == 0){
      //     this.total = Number(ret.count);
      //     this.tableData = ret.data;
      //   }else{
      //     this.$message({message: ret.msg,type: 'error'});
      //   }
      // });

      var param = 'studentId=' + this.seeStudentId +
      '&teacherOpenCourseId=' + this.teacherOpenCourseId + 
      '&teacherOpenCourseStudentSigninSettingId=' + this.signinSettingId + 
      '&teacherOpenCourseStudentSigninSettingSessionTime=' +  this.value1 + 
      '&teacherOpenCourseStudentSigninLogRemark=' + this.teacherOpenCourseStudentSigninLogRemark +
      '&teacherOpenCourseStudentSigninLogTag=' +  this.teacherOpenCourseStudentSigninLogTag
      window.open(this.$baseUrl + "/api/teacherOpenCourseStudentSigninLog/export.do?" + param);

        // window.open(this.$baseUrl + "/api/teacherOpenCourseStudentSigninLog/export.do?teacherOpenCourseId="+this.teacherOpenCourseId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    changeRemark(item){ //修改缺勤备注
      let param = {
        teacherOpenCourseStudentSigninLogId:item.teacherOpenCourseStudentSigninLogId,
        teacherOpenCourseStudentSigninLogRemark:item.teacherOpenCourseStudentSigninLogRemark
      }
      this.$post("/api/teacherOpenCourseStudentSigninLog/editReasonForAbsence.do",param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success("操作成功！");
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-ErrorSet{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/SignInDetails.vue